import { SVGComponentProps } from "./utils/Types"

const ChevronRightIcon = ({
    width = 16,
    height = 16,
    className,
}: SVGComponentProps) => {
    return (
        <svg
            className={`text-current ${className}`}
            fill="currentColor"
            width={width}
            height={height}
            viewBox="0 0 16 16"
        >
            <path d="M6 3l4 5-4 5" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export default ChevronRightIcon